"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterMunicipalitiesBasedOnFactor = exports.getRespondentType = void 0;
var lodash_1 = __importDefault(require("lodash"));
var counties_1 = require("../../../fixtures/counties");
function getRespondentType(groupingService, factorService, selectedFactorSlug, respondentType, chartingLabel) {
    var _a;
    if (groupingService.getFactorGroup(selectedFactorSlug) === 'survey'
        && factorService.isRespondentTypeApplicable(selectedFactorSlug, chartingLabel)) {
        if (!((_a = factorService.getComparisonConfig(selectedFactorSlug, chartingLabel)) === null || _a === void 0 ? void 0 : _a.isApplicableToPoliticians)) {
            return 'Företagare';
        }
        else {
            if (respondentType === undefined) {
                return 'Företagare';
            }
            else {
                return respondentType;
            }
        }
    }
    else {
        return undefined;
    }
}
exports.getRespondentType = getRespondentType;
function filterMunicipalitiesBasedOnFactor(comparisonConfig, comparisonMunicipalities0, selectedMunicipalities0) {
    // filter out counties from selected/comparison regions, will be kept in state but invisible until a valid factor is chosen
    var noCounties = comparisonConfig.lacksCountyData;
    var comparisonMunicipalities = noCounties ? lodash_1.default.difference(comparisonMunicipalities0, counties_1.CountyNames) : comparisonMunicipalities0;
    var selectedMunicipalities = noCounties ? lodash_1.default.difference(selectedMunicipalities0, counties_1.CountyNames) : selectedMunicipalities0;
    // like above, but Sweden
    var excludeSweden = comparisonConfig.excludeSweden;
    comparisonMunicipalities = excludeSweden ? lodash_1.default.difference(comparisonMunicipalities, [counties_1.Sweden]) : comparisonMunicipalities;
    selectedMunicipalities = excludeSweden ? lodash_1.default.difference(selectedMunicipalities, [counties_1.Sweden]) : selectedMunicipalities;
    return { comparisonMunicipalities: comparisonMunicipalities, selectedMunicipalities: selectedMunicipalities };
}
exports.filterMunicipalitiesBasedOnFactor = filterMunicipalitiesBasedOnFactor;
